import PropTypes from "prop-types";
import React from "react";
import FooterSocial from "./partials/FooterSocial";
import { Link } from "react-router-dom";

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool,
};

const defaultProps = {
  topOuterDivider: false,
  topDivider: false,
};

const UpdatedFooter = ({
  className,
  topOuterDivider,
  topDivider,
  ...props
}) => {
  return (
    <footer {...props} className="footer olake-layout-container">
      <div className="container">
        <div className="left">
          <img
            src={require("../../assets/images/datazip-footer-logo.svg")}
            alt="tooltip"
          />
          <div className="updated-footer-heading">
            Your Partner in <span>Apache Iceberg</span> Adoption
          </div>
          <FooterSocial />
          <div className="footer-alignment">
            <FooterSocial />
          </div>
        </div>
        <div className="right">
          <div className="types">
            <div className="updated-type-heading type-heading">Company</div>
            <ul>
              <Link to="/about-us">
                <li>About us</li>
              </Link>
            </ul>
          </div>
          <div className="types">
            <div className="updated-type-heading type-heading">Legal</div>
            <ul>
              <Link to="/privacy-policy">
                <li>Privacy (Visitors)</li>
              </Link>
              <Link to="/privacy-policy-customer">
                <li>Privacy (Customers)</li>
              </Link>
              <Link to="/terms-of-use">
                <li>Terms of Use</li>
              </Link>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

UpdatedFooter.propTypes = propTypes;
UpdatedFooter.defaultProps = defaultProps;

export default UpdatedFooter;
